import React from "react";
import ReactDOM from "react-dom";
import SignUpForm from "./Pages/sign-up/sign-up-form/SignUpForm";
import EmailSignupForm from "./Components/organisms/email-signup/EmailSignupForm";
import ApiClient from "./Helpers/ApiClient";
import drupalSettings from "./Helpers/drupalSettings";
import "./sass/sign-up-modal.scss";

window.Drupal.behaviors.signUpModal = {
  attach() {
    const el = document.getElementById("inner-circle-registration");
    if (!el || el.hasAttribute("data-react-mounted")) return;

    // If logged in skip the sign-up rendering.
    if (localStorage.getItem("isLoggedIn") === "true") return;

    const { api_url: url, api_key: key } = drupalSettings.ed_dashboard;
    const lang = drupalSettings.path.currentLanguage;

    const dialog = document.getElementById("inner-circle-modal");

    const commerceEnabledMarkets =
      drupalSettings.ed_commerce?.config?.commerce_enabled_markets;

    const deliveryMarket =
      localStorage.getItem("deliveryLocation") ||
      drupalSettings.regionMarket.market ||
      drupalSettings.regionMarket.location;

    const isCommerceMarket = Array.isArray(commerceEnabledMarkets)
      ? !commerceEnabledMarkets.length ||
        commerceEnabledMarkets.includes(deliveryMarket)
      : false;

    ReactDOM.render(
      isCommerceMarket ? (
        <SignUpForm
          client={new ApiClient(url, lang, key)}
          location={window.location}
          onComplete={() => dialog?.close()}
          fullWidth
        />
      ) : (
        <EmailSignupForm
          client={new ApiClient(url, lang, key)}
          onComplete={() => dialog?.close()}
        />
      ),
      el
    );

    el.setAttribute("data-react-mounted", "true");
  }
};
